<div class="app-container">
  <header>
    <app-header
      [showGlobalSearch]="true"
      [globalSearchLabel]="'globalSearch.open' | transloco"
      (globalSearchRequested)="openGlobalSearch()"
    >
      <app-environment-banner environment-banner></app-environment-banner>
    </app-header>
  </header>
  <main>
    @if (isLoginRoute()) {
      <div class="app-login-content">
        <router-outlet></router-outlet>
      </div>
    } @else {
      <app-side-nav
        [showGlobalSearch]="true"
        [globalSearchLabel]="'globalSearch.open' | transloco"
        (globalSearchRequested)="openGlobalSearch()"
      >
        <router-outlet></router-outlet>
      </app-side-nav>
    }
  </main>
  <footer>
    <p>{{ 'footer.rights' | transloco }}</p>
    <app-page-help [route]="currentRoute()" [globalSearchContext]="globalSearchContext()" />
  </footer>
</div>

<!-- Floating notification badge (visible on all pages) -->
<ccfx-badge
  triggerMode="click"
  panelTitle="Pending Approvals"
  [count]="pendingApprovals.totalCount()"
  [loading]="pendingApprovals.loading()"
  [categories]="pendingApprovals.categories()"
  (refreshRequested)="pendingApprovals.refresh()"
/>
